/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import * as fromValidate from 'Simple/Data/validate.js'
import React from 'react'
import TysiaSelect from 'DesignSystem/TysiaSelect/index'
import TysiaSelectContent from 'DesignSystem/TysiaSelect/TysiaSelectContent/index'
import TysiaSelectField from 'DesignSystem/TysiaSelect/TysiaSelectField/react'
import TysiaSelectLabel from 'DesignSystem/TysiaSelect/TysiaSelectLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/WaitingRoom/Content/Content/Waiting/Appointments/Content/Appointment/Action/Seat/Confirmation/Content/Provider/Content",
  onChange,
  isInvalid
  
}) {
let providersValueData = fromData.useDataFormat({ viewPath,
context: 'providers',
format: fromHelpers.getProviders,
})
let seatProviderIdValueData = fromData.useDataValue({ viewPath,
context: 'seat',
path: 'provider_id',
})
let seatProviderIdIsValidData = fromData.useDataIsValid({ viewPath,
context: 'seat',
path: 'provider_id',
validate: fromValidate.number,
required: true,
})
let seatProviderIdChangeData = fromData.useDataChange({ viewPath,
context: 'seat',
path: 'provider_id',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaSelect
  viewPath={`${viewPath}/TysiaSelect`}
 data="providers"
 format="helpers.js getProviders"
 from={providersValueData}
 data="seat.provider_id"
 value={seatProviderIdValueData}
 onChange={seatProviderIdChangeData}
 required={true}
 validate="/Simple/Data/validate.js number"
 invalid={!seatProviderIdIsValidData}
 alignItems="stretch"
 textAlign="left"
 minWidth="100%"
 maxWidth="100%"
 width="100%"
 marginBottom={dtSpaceS}
>
{childProps => (
<React.Fragment>
<TysiaSelectLabel
{...childProps}
  viewPath={`${viewPath}/TysiaSelectLabel`}
 text="Provider"
/>
<TysiaSelectContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectContent`}
>
{childProps => (
<TysiaSelectField
{...childProps}
  viewPath={`${viewPath}/TysiaSelectField`}
/>
)}
</TysiaSelectContent>
</React.Fragment>
)}
</TysiaSelect>
{children}
</React.Fragment>)
}